import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("popu-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "AHORA";
  if (mins < 60) return `HACE ${mins} MIN`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `HACE ${hours} HORA${hours > 1 ? "S" : ""}`;
  const days = Math.floor(hours / 24);
  return `HACE ${days} DÍA${days > 1 ? "S" : ""}`;
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("es-AR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
